import { Box, Container, Stack, Typography, Unstable_Grid2 as Grid } from '@mui/material';

import { AccountProfile } from './account-profile';
import { AccountProfileDetails } from './account-profile-details';
import { ProfileModel } from '../../models/profile.model';

export default function ProfileScreen2(props: { 
  profile: ProfileModel,
  profileEdit: ProfileModel,
  changeProfileEdit: any,
  uploadAvatar: any,
  saveProfileEdit: any,
 }) {

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        paddingBottom: 15,
        paddingTop: 5,
      }}
    >
      <Container maxWidth="lg">
        <Stack spacing={3}>
          <div>
            <Typography variant="h4">
              Perfil
            </Typography>
          </div>
          <div>
            <Grid
              container
              spacing={3}
            >
              <Grid
                xs={12}
                md={6}
                lg={4}
              >
                <AccountProfile {...props} />
              </Grid>
              <Grid
                xs={12}
                md={6}
                lg={8}
              >
                <AccountProfileDetails {...props} />
              </Grid>
            </Grid>
          </div>
        </Stack>
      </Container>
    </Box>

  );

 }

